import { queryClient } from '@frontend/sorghum/external-providers';
import {
  LinkedAccountInfo,
  LinkedAccountSignupType,
  ProjectConnectRequest,
  Response,
} from '@frontend/sorghum/interface';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { PROJECT_CONNECT } from '../apis';

async function postProjectConnect(
  props: ProjectConnectRequest,
): Promise<Response & { data?: LinkedAccountInfo }> {
  return axios.post(PROJECT_CONNECT, props).then((res) => res.data);
}

export function usePostProjectConnect() {
  const [t] = useTranslation();
  return useMutation({
    mutationKey: ['project-connect'],
    mutationFn: (props: ProjectConnectRequest) => postProjectConnect(props),
    onSuccess: (data, variables) => {
      if (data.code === 20000) {
        queryClient.invalidateQueries(['facebook-pages']);
        queryClient.invalidateQueries(['project-linked']);
        queryClient.invalidateQueries(['get-project-list']);
        queryClient.invalidateQueries(['get-account-info']);
        queryClient.invalidateQueries([
          'get-project',
          { projectID: variables.projectId },
        ]);
      } else if (data.code === 40102) {
        // 40102 = 該社群帳號已連結至其他專案。顯示「已由誰綁定」讓客戶想起是自己的舊帳號綁的、
        // 不用進客服（智解家案：客戶換帳號後誤以為粉專綁定消失）。email 已由後端遮罩。
        // 綁定者資訊可能缺漏（後端查不到帳號），逐級 fallback 回 generic 訊息。
        const info = data.data;
        const signupTypeLabel =
          info?.signupType === LinkedAccountSignupType.FB
            ? t('pages.signupTypeFb')
            : info?.signupType === LinkedAccountSignupType.EMAIL
            ? t('pages.signupTypeEmail')
            : null;
        if (info?.accountEmail && signupTypeLabel) {
          toast.warning(
            t('pages.isConnectedBy', {
              account: info.accountEmail,
              signupType: signupTypeLabel,
            }),
          );
        } else if (signupTypeLabel) {
          toast.warning(t('pages.isConnectedByType', { signupType: signupTypeLabel }));
        } else {
          toast.warning(t('pages.isConnected'));
        }
      } else {
        toast.warning(t('pages.modal.error'));
      }
    },
  });
}

export default usePostProjectConnect;
